import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '@app/utils/constants/regex.constants';

const NAME_MIN_LENGTH = 2;
const NAME_MAX_LENGTH = 30;
const EMAIL_MAX_LENGTH = 256;

export function customerNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;

    if (!value) {
      return { invalidName: true };
    }

    if (value.length < NAME_MIN_LENGTH || value.length > NAME_MAX_LENGTH) {
      return { invalidName: true };
    }

    if (!REGEX.name.test(value)) {
      return { invalidName: true };
    }

    return null;
  };
}

export function customerEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;

    if (!value) {
      return { invalidEmail: true };
    }

    if (value.length > EMAIL_MAX_LENGTH) {
      return { invalidEmail: true };
    }

    if (!REGEX.email.test(value)) {
      return { invalidEmail: true };
    }

    return null;
  };
}

export function customerRemarksValidator(min = 2, max = 100): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;

    if (!value) {
      return null;
    }

    const isLengthValid = value.length >= min && value.length <= max;
    const isFormatValid = REGEX.remarks.test(value);

    if (!isLengthValid || !isFormatValid) {
      return { invalidRemarks: true };
    }

    return null;
  };
}

export function optional(validator: ValidatorFn): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    return validator(control);
  };
}
